import script from "./ModelManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModelManager.vue?vue&type=script&setup=true&lang=ts"

import "./ModelManager.vue?vue&type=style&index=0&id=063d1eae&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-063d1eae"]])

export default __exports__